import createNewCharacterRuneEntry from '../helpers/createNewCharacterRuneEntry'
import trackRuneChanges from '../helpers/trackRuneChanges.js'
import loadTraits from '../helpers/loadTraits.js'

import processCopyStaticRuneAdjs from '../processes/processCopyStaticRuneAdjs'

import store from '../store/index'

function getNextRuneDisplayName({ baseName, existingRunes }) {
  const normalizedBaseName = String(baseName ?? '').trim()
  if (!normalizedBaseName) {
    return null
  }

  const pattern = new RegExp(
    `^${normalizedBaseName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}(?: (?<num>\\d+))?$`,
    'i',
  )

  let maxSuffix = 0

  for (const rune of existingRunes || []) {
    const visibleName = String(rune?.display_name ?? rune?.name ?? '').trim()
    if (!visibleName) {
      continue
    }

    const match = visibleName.match(pattern)
    if (!match) {
      continue
    }

    const suffix = match.groups?.num
    if (!suffix) {
      maxSuffix = Math.max(maxSuffix, 1)
      continue
    }

    const parsedSuffix = Number.parseInt(suffix, 10)
    if (!Number.isNaN(parsedSuffix)) {
      maxSuffix = Math.max(maxSuffix, parsedSuffix)
    }
  }

  if (maxSuffix === 0) {
    return null
  }

  return `${normalizedBaseName} ${maxSuffix + 1}`
}
//------------------
// process add rune
//------------------
export default function processAddRune({
  parms = {},
  changed_runes = [],
  original_runes = [],
  character = null,
} = {}) {
  console.log('--------------------------------------')
  console.log('IN processAddRune parms = ', parms)
  //-----------
  // get parms
  //-----------
  const track_rune = parms.payload ?? {} // includes temp id for tracking
  const static_rune_id = parms.payload.rune ?? null
  const strength = parms.payload.strength ?? 0
  const pwr_storage = parms.payload.pwr_storage ?? 0
  const starter = parms.payload.starter ?? false
  const already_integrated = parms.payload.already_integrated ?? false
  const integrated = parms.payload.integrated ?? false
  const character_item = parms.payload.character_item ?? null
  const item_name = parms.payload.item_name ?? null
  const character_id = character?.id ?? null

  console.log('RUNE TO ADD = ', track_rune)
  //----------
  // declares
  //----------
  let requireRuneCastingSkill = false
  let requireApplyRuneAdjs = false
  //-----------------
  // get static rune
  //-----------------
  console.log('1. off to get static rune')
  let static_rune = static_rune_id
    ? store.getters['characters/getStaticRune'](static_rune_id)
    : null

  console.log('##### static_rune = ', static_rune)
  //---------------
  // set base rune name
  //---------------
  const base_name = static_rune?.name ?? 'Unnamed Rune'
  track_rune.name = base_name

  //------------------------------------------------------
  // if rune name already exists - compute UI-only suffix
  // (mirrors CharacterItem display_name behaviour)
  //------------------------------------------------------
  const newDisplayName = getNextRuneDisplayName({
    baseName: base_name,
    existingRunes: character?.runes ?? [],
  })

  // Always derive the display name fresh from the character's current
  // runes - never trust a stale/incoming display_name already present on
  // the payload (e.g. carried over from a copy/edit elsewhere).
  track_rune.display_name = newDisplayName
  //-------------------------------
  // update tracking with new rune
  //-------------------------------
  console.log('2. off to track rune changes')
  changed_runes = trackRuneChanges({
    rune: track_rune,
    original_runes,
    changed_runes,
    character_id,
  })
  //---------------------------------
  // create new character rune entry
  //---------------------------------
  console.log('3. off to create new character rune entry')
  let new_rune = createNewCharacterRuneEntry({
    id: track_rune.id, // temp id used for tracking
    static_rune: static_rune,
    strength: strength,
    pwr_storage: pwr_storage,
    starter: starter,
    already_integrated: already_integrated,
    integrated: integrated,
    short_powers: static_rune?.short_powers ?? '',
    powers: static_rune?.powers ?? '',
    trait: static_rune?.trait_name ?? '',
    character_item: character_item,
    item_name: item_name,
    character: character.id ? character.id : null,
    display_name: newDisplayName,
  })
  console.log('character.runes = ', character.runes)
  //-----------------------------
  // add rune to character runes
  //-----------------------------
  character.runes.push(new_rune)
  console.log('NEW RUNE ADDED TO CHARACTER = ', new_rune)
  //----------------------------
  // check for rune integration
  //----------------------------
  if (integrated) {
    console.log('4. rune integrated')
    console.log('RRRRR character = ', window.$deepCopy(character))
    //----------------------------------------------------
    // get cnt of runes with name same already integrated
    //----------------------------------------------------
    const integrated_rune_cnt = character.runes.filter(
      (r) => r.name == track_rune.name && r.integrated,
    )
    //---------------------------------------------------
    // if same integrated rune count = zero:
    // - only add runecasting skill for given rune once
    // - only apply adjs from static rune once
    console.log('5. integrated_rune_cnt = ', integrated_rune_cnt)
    if (integrated_rune_cnt.length == 1) {
      console.log('6. no same rune integrated')
      //---------------------------------
      // flag runecasting skill required
      //---------------------------------
      requireRuneCastingSkill = true
      //------------------------------------------------------------------------
      // process add rune adjs (load approp adjs from static rune to this rune)
      //------------------------------------------------------------------------
      console.log('7. off to process rune adjs new_rune = ', window.$deepCopy(new_rune))
      const res = processCopyStaticRuneAdjs({ static_rune, target_rune: new_rune, character })
      console.log('7b. new_rune = ', window.$deepCopy(new_rune))

      console.log('SSSSS character = ', window.$deepCopy(character))
      //---------------
      // load response
      //---------------
      if (res) {
        new_rune = res.target_rune
        character = res.character
        console.log('TTTTT new_rune = ', window.$deepCopy(new_rune))
        console.log('UUUUU character = ', window.$deepCopy(character))
        //-------------------------------
        // flag apply rune adjs required
        //-------------------------------
        requireApplyRuneAdjs = true
      }
    } else {
      console.log('>>>> same rune integrated found - skip creating runecasting skill')
    }
  } else {
    console.log('>>>> new rune not integrated')
  }
  //------------------------------------
  // update traits where rune has trait
  //------------------------------------
  console.log('DX.1 rune = ', new_rune.name, ' has trait = ', new_rune.trait)
  if (new_rune.trait) {
    console.log('DX.2 off to reloadTraits to add rune trait')
    character = loadTraits({ character })
  }
  console.log('8. completed processAddRune new rune = ', new_rune)
  //------------------------------------------------------------
  // update any character item with rune (reverse relationship)
  //------------------------------------------------------------
  if (character_item) {
    const item = character.items.find((i) => i.id === character_item)
    if (item) {
      if (!item.runes) {
        item.runes = []
      }
      item.runes.push(new_rune) // whole object as per download
    }
  }
  //------------------------
  // return mutated objects
  //------------------------
  return { changed_runes, new_rune, character, requireRuneCastingSkill, requireApplyRuneAdjs }
}
